import { useAuth } from '../store/auth';

/**
 * Permission checks in one place. The server enforces them regardless — this
 * only decides whether it is fair to show somebody a button that would be
 * refused.
 */
export function usePermission(): { can: (permission: string) => boolean; canAny: (...p: string[]) => boolean } {
  const can = useAuth((s) => s.can);
  return { can, canAny: (...permissions: string[]) => permissions.some((p) => can(p)) };
}
